import {addEdgeGeometry, createCube} from "../../utils/threeUtils";
import {Box3, Vector3} from "three";
import * as Globals from '../../globals';
import {buildingGroup} from "../../main";
import {pad, toFixedFloat} from "../../utils/utils";
import {setObjectLayer} from "../../utils/layerUtils";
import {getVolume} from "../../utils/volumeUtils";
import {pathPointsClockwise} from "../../utils/shapeUtils";
import {wallMaterial} from "../../constants/materialConstants";
import {attikaMeshName} from "../../constants/nameConstants";

export class Attika {
    constructor(roof, roofPoints, height) {
        this.roof = roof;
        this.roofPoints = roofPoints;
        this.height = height;
    }

    create() {
        let roofPoints = this.roofPoints;
        if (!pathPointsClockwise(roofPoints)) {
            roofPoints = roofPoints.reverse();
        }

        roofPoints = this.generateAttikaSegments(roofPoints);
        setObjectLayer(this.roof, Globals.layers.roof, true);
    }

    generateAttikaSegments(roofPoints) {
        roofPoints = indentRoofPoints(roofPoints, true, 0.05);

        let cubes = [];
        for (let i = 0; i < roofPoints.length - 1; i++) {
            let firstPoint = roofPoints[i];
            let secondPoint = i !== roofPoints.length - 2 ? roofPoints[i + 1] : roofPoints[0];
            let direction = new Vector3().subVectors(secondPoint, firstPoint);
            let length = direction.length();
            let position = new Vector3().copy(firstPoint).add(direction.multiplyScalar(0.5));
            let roofBounds = new Box3().setFromObject(this.roof);
            position.y = roofBounds.max.y + (this.height / 2);

            let cube = createCube(length, Globals.HBEWallDefaultThickness, this.height, position, buildingGroup, wallMaterial);
            cube.name = attikaMeshName + pad(i, 3);
            let volume = toFixedFloat(getVolume(cube.geometry), 7);
            cube.userData.originalVolume = volume;
            cube.userData.sizedVolume = volume;
            cube.userData.depth = Globals.HBEWallDefaultThickness;
            cube.userData.height = this.height;
            cube.userData.width = length;

            addEdgeGeometry(cube);
            cubes.push(cube);

            if (Math.abs(direction.z) > Math.abs(direction.x)) {
                cube.rotation.y = Math.PI / 2;
                if (direction.z > 0) {
                    cube.position.z += 0.05;
                } else {
                    cube.position.z -= 0.05;
                }
            } else {
                if (direction.x > 0) {
                    cube.position.x += 0.05;
                } else {
                    cube.position.x -= 0.05;
                }
            }

            cube.position.y += 0.0015; //Toleranz für Line Rendering
        }

        for (let i = 0; i < cubes.length; i++) {
            this.roof.attach(cubes[i]);
        }

        return roofPoints;
    }
}

function indentRoofPoints(roofPoints, isClockwise, offset) {
    roofPoints = [...roofPoints];
    let axis = new Vector3(0, 1, 0);
    let angle = isClockwise ? -Math.PI / 2 : Math.PI / 2;

    for (let i = 0; i < roofPoints.length - 1; i++) {
        let p0 = roofPoints[i];
        let p1 = i !== roofPoints.length - 2 ? roofPoints[i + 1] : roofPoints[0];

        let vector = new Vector3(p1.x - p0.x, 0, p1.z - p0.z);
        vector.applyAxisAngle(axis, angle);
        vector.clampLength(offset, offset);
        roofPoints[i].add(vector);
        roofPoints[i + 1].add(vector);
        if (i === 0) {
            roofPoints[roofPoints.length - 1].add(vector);
        } else if (i === roofPoints.length - 2) {
            roofPoints[0].add(vector);
        }
    }

    return roofPoints;
}
